import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { store } from 'store';
import { refreshToken } from 'store/settings/actions';
import i18next from 'i18next';
import _has from 'lodash/has';
import { createTranslationsConfig } from 'utils';

export type { AxiosResponse } from 'axios';

const axiosInstance = axios.create();
const urlWithoutToken = ['/token'];

axiosInstance.interceptors.request.use((config) => {
  if (config.url && !urlWithoutToken.includes(config.url)) {
    const { access_token } = store.getState().settings;

    config.headers = {
      'Content-Type': 'application/json',
      Authorization: `bearer ${access_token}`,
    };
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest: typeof error.config & { _retry?: boolean } =
      error.config;

    console.log(error);
    if (error.response?.status === 503) {
      window.location.reload();
    }

    if (
      error.response?.status === 401 &&
      error.config.url !== '/login/check' &&
      !_has(originalRequest, '_retry')
    ) {
      originalRequest['_retry'] = true;

      const token = await refreshToken();

      if (token) {
        axiosInstance.defaults.headers.common['Authorization'] =
          'Bearer ' + token;

        return axiosInstance(originalRequest);
      }
    }

    return Promise.reject(error);
  }
);

export const fetchTranslations = async (translationKeys: string[]) => {
  const serverTranslations: Array<{ Id: string; String: string }> = (
    await axiosInstance.post('/api/localization', translationKeys)
  ).data.Data;
  const config = createTranslationsConfig(serverTranslations);

  i18next.addResources('fi', 'server', config);
  // i18next.addResourceBundle('fi', 'server', config, true, false);
};

export type RequestConfig = AxiosRequestConfig;
export type ServiceError = AxiosError;
export default axiosInstance;
